import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

// Ant Design
import { Breadcrumb } from "antd";
import { HomeOutlined } from "@ant-design/icons";

// project imports
import MainCard from "../MainCard";
import { useTranslation } from "react-i18next";
import { useResponsive } from '@/hooks/useResponsive';

// ==============================|| BREADCRUMBS ||============================== //

const Breadcrumbs = ({ navigation, title, titleBottom, card, divider, ...others }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const [main, setMain] = useState();
  const [item, setItem] = useState();
  const [refresh, setRefresh] = useState(true);
  const { isDesktop } = useResponsive();

  // set active item state
  const getCollapse = (menu) => {
    if (menu.children) {
      menu.children.filter((collapse) => {
        if (collapse?.type && collapse?.type === "collapse") {
          getCollapse(collapse);
        } else if (collapse?.type && collapse?.type === "item") {
          if (location.pathname === collapse.url) {
            setMain(menu);
            setItem(collapse);
            localStorage.setItem("menu", JSON.stringify(menu));
            localStorage.setItem("item", JSON.stringify(collapse));
          } else {
            setRefresh(false);
          }
        }
        return false;
      });
    }
  };

  useEffect(() => {
    navigation?.items?.map((menu) => {
      if (menu.type && menu.type === "group") {
        getCollapse(menu);
      }
      if (refresh === false) {
        try {
          const menuData = localStorage.getItem("menu");
          const itemData = localStorage.getItem("item");
          if (menuData && menuData !== "undefined") {
            setMain(JSON.parse(menuData));
          }
          if (itemData && itemData !== "undefined") {
            setItem(JSON.parse(itemData));
          }
        } catch (error) {
          console.error("Error parsing breadcrumb data:", error);
        }
        setRefresh(true);
      }
      return false;
    });
  }, [navigation]);

  // only used for component demo breadcrumbs
  if (location.pathname === "/breadcrumbs") {
    location.pathname = "/dashboard/analytics";
  }

  // Build breadcrumb items
  const breadcrumbItems = [];

  // Home item
  breadcrumbItems.push({
    title: (
      <Link to="/recipe-view" className="flex items-center gap-1 text-gray-600 dark:text-gray-400 hover:text-blue-600 no-underline">
        <HomeOutlined className="mr-2" />
        <span>{t("Home")}</span>
      </Link>
    ),
  });

  // Main/collapse item
  if (main && main.type === "collapse") {
    breadcrumbItems.push({
      title: (
        <Link
          to={main?.children[0]?.url}
          className="text-gray-600 dark:text-gray-400 hover:text-blue-600 no-underline"
        >
          {main.title}
        </Link>
      ),
    });
  }

  // Current item
  if (item && item.type === "item") {
    breadcrumbItems.push({
      title: (
        <span className="text-gray-900 dark:text-gray-100 font-medium">
          {item.title}
        </span>
      ),
    });
  }

  // Return breadcrumb or empty div
  if (item && item.type === "item" && item.breadcrumbs !== false) {
    return (
      <MainCard
        border={false}
        className="mb-2 bg-transparent"
        {...others}
        content={false}
      >
        <div className="flex flex-col justify-start items-start mt-2">
          <Breadcrumb items={breadcrumbItems} />
        </div>
      </MainCard>
    );
  }

  return <div />;
};

Breadcrumbs.propTypes = {
  navigation: PropTypes.object,
  title: PropTypes.bool,
  titleBottom: PropTypes.bool,
  card: PropTypes.bool,
  divider: PropTypes.bool,
};

export default Breadcrumbs;
